import {
	Box,
	CircularProgress,
	Grid,
	Typography,
	PageHeading,
	Paper,
} from 'components';
import { LoginForm } from 'components/account/login-form';
import { JoinCommunityCard } from 'components/community/request-to-join';
import { useGetPublicCommunity } from 'core/uses-cases/community';
import { useTranslation } from 'hooks';
import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

export const RequestToLogin = () => {
	const { communityId } = useParams() as { communityId: string };
	const { data, isLoading } = useGetPublicCommunity(communityId);
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();

	const email = searchParams.get('email') ?? '';

	const initialValues = useMemo(
		() => ({
			username: email ?? '',
		}),
		[email]
	);

	if (isLoading || !data) {
		return (
			<Box display='flex' justifyContent='center' mt={4}>
				<CircularProgress message={t('common.loading')} />
			</Box>
		);
	}

	return (
		<>
			<PageHeading title={data?.name}>
				<Grid container>
					<Grid size={{ xs: 12, md: 6 }}>
						<Typography variant='body2'>
							{t('request-to-login.private-message')}
						</Typography>
					</Grid>
				</Grid>
			</PageHeading>
			<Grid container spacing={6} mt={0}>
				<Grid size={{ xs: 12, md: 4 }}>
					<JoinCommunityCard community={data} />
				</Grid>
				<Grid size={{ xs: 12, md: 8 }}>
					<Box component={Paper} elevation={0} px={5} py={5}>
						<LoginForm initialValues={initialValues} />
					</Box>
				</Grid>
			</Grid>
		</>
	);
};
